import React from "react";
import { Col, Card, Badge } from "react-bootstrap";
import "./Platillos.css";

const Platillos = ({ index, card, returnSelected, detalleOrden }) => {
  const dias = [
    "domingo",
    "lunes",
    "martes",
    "miercoles",
    "jueves",
    "viernes",
    "sabado",
  ];
  const fecha = new Date();
  const fechaActual = fecha.toISOString().split("T")[0];
  const numeroDia = new Date().getDay();
  const nombreDia = dias[numeroDia];
  let restante = card.piezas;
  if (card.fechas && card.fechas[fechaActual]) {
    let acum = 0;
    Object.keys(card.fechas[fechaActual]).forEach((ittem) => {
      acum += card.fechas[fechaActual][ittem];
    });
    restante = restante - acum;
  }
  if (card.reservados && card.reservados[fechaActual]) {
    let acum = 0;
    Object.keys(card.reservados[fechaActual]).forEach((ittem) => {
      acum += card.reservados[fechaActual][ittem];
    });
    restante = restante - acum;
  }
  if (detalleOrden) {
    const itemtime = detalleOrden?.filter((ite) => {
      return ite.id === card.id && ite.selectedDate === fechaActual;
    });
    const cant = itemtime.reduce((acom, ita) => acom + ita.cantidad, 0);
    restante = restante - cant;
  }
  let disabled = "";
  if (card.limite && restante <= 0) {
    disabled = "AGOTADO HOY";
  }
  if (card.modo === "RECOGER CON HORARIO" && card[nombreDia]?.active) {
    const horaFin = new Date("2026-01-01T" + card[nombreDia].fin);
    const horaFinal = horaFin.getHours();
    const minutosFinal = horaFin.getMinutes();
    const current = new Date();
    const horaActual = current.getHours();
    const minutosActual = current.getMinutes();
    if (
      horaFinal < horaActual ||
      (horaFinal === horaActual && minutosFinal < minutosActual)
    ) {
      disabled = "AGOTADO";
    }
  } else if (card.modo === "RECOGER CON HORARIO" && !card[nombreDia]?.active) {
    disabled = "NO DISPONIBLE HOY";
  }
  let colorT = "white";
  let colorB = "color-orange";
  let texto = "PEDIDO PARA HOY";
  if (card.modo === "PREVENTA") {
    colorT = "white";
    colorB = "color-purple";
    texto = "PREVENTA DISPONIBLE";
  } else if (card.modo === "RECOGER CON HORARIO") {
    colorT = "white";
    colorB = "color-brown";
    texto = "PEDIDO CON HORARIO";
  }
  return (
    <Col xs={12} sm={6} md={4} key={index} className="d-flex mb-3">
      <Card
        key={card.id}
        // style={{ width: "170px" }}
        onClick={() => returnSelected(card)}
      >
        {/* <Card.Header> */}

        {/* </Card.Header> */}
        {disabled !== "" && (
          <Badge
            className="color-red"
            bg="gray"
            style={{
              color: "white",
              fontSize: 11,
              alignSelf: "flex-start",
              fontWeight: "500",
              paddingHorizontal: 6,
              marginHorizontal: "auto",
              marginVertical: 10,
              width: "100%",
              borderRadius: 5,
            }}
          >
            {disabled}
          </Badge>
        )}
        <Card.Img variant="top" src={card.img} />
        <Card.Footer>
          {card.name}
          <br />
          <Badge
            bg="gray"
            color="black"
            className={colorB}
            style={{
              color: colorT,
              fontSize: 11,
              fontWeight: "500",
              borderRadius: 5,
            }}
          >
            {texto}
          </Badge>
          {card.mensaje && (
            <Badge
              className="color-time"
              bg="gray"
              color="black"
              text="dark"
              style={{
                fontSize: 13,
                alignSelf: "flex-start",
                fontWeight: "500",
                borderRadius: 5,
              }}
            >
              {card?.estimado} minutos.
            </Badge>
          )}
          {disabled === "" && card.limite && restante > 0 && (
            <>
              <br />
              <Badge
                className="color-pz"
                bg="light"
                text="dark"
                style={{
                  fontSize: 14,
                  alignSelf: "flex-start",
                  fontWeight: "500",
                  // paddingHorizontal: 6,
                  // marginHorizontal: "auto",
                  // marginVertical: 5,
                  // width: "100%",
                  borderRadius: 5,
                  backgroundColor: "white",
                }}
              >
                {restante} Pz
              </Badge>
            </>
          )}
        </Card.Footer>
      </Card>
    </Col>
  );
};

export default Platillos;
